/* V408 — retour navigateur : préserver la position sans remplacer l'historique natif.
   Sauvegarde limitée aux coordonnées de défilement de cette session (aucun profil client). */
(function () {
  'use strict';
  const PREFIX = 'lpV408BackPosition:';
  const MAX_AGE = 30 * 60 * 1000;
  const key = () => PREFIX + location.pathname + location.search + location.hash;
  const canStore = () => {
    try { return !!window.sessionStorage; } catch (error) { return false; }
  };
  function save() {
    if (!canStore()) return;
    try {
      sessionStorage.setItem(key(), JSON.stringify({
        y: Math.max(0, Math.round(window.scrollY || window.pageYOffset || 0)),
        at: Date.now()
      }));
    } catch (error) {}
  }
  function read() {
    if (!canStore()) return null;
    try {
      const saved = JSON.parse(sessionStorage.getItem(key()) || 'null');
      if (!saved || !Number.isFinite(saved.y) || saved.y < 0 ||
          !Number.isFinite(saved.at) || Date.now() - saved.at > MAX_AGE) return null;
      return saved.y;
    } catch (error) { return null; }
  }
  function restore() {
    const y = read();
    if (y === null) return;
    // On laisse les sections et les onglets de la page se rétablir avant
    // d'ajuster le défilement. Le navigateur conserve son mode "auto".
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      if (max < y) return; // Page dynamique incomplète : ne pas envoyer le visiteur au mauvais endroit.
      window.scrollTo({top:y, behavior:'instant'});
    }));
  }
  // Les onglets Maison utilisent pushState sans recharger la page.
  // Mémoriser l'ancienne position avant que l'URL (son hash) change.
  document.addEventListener('click', event => {
    const a = event.target.closest('a[href]');
    if (!a || !a.href) return;
    try {
      const target = new URL(a.href, location.href);
      if (target.origin !== location.origin) return;
      if (target.pathname === location.pathname && target.search === location.search &&
          target.hash !== location.hash) save();
    } catch (error) {}
  }, {capture:true, passive:true});
  window.addEventListener('pagehide', save);
  // Un clic Retour d'un autre document : le navigateur fait d'abord son
  // propre travail; on ne complète que les navigations réellement "back_forward".
  window.addEventListener('pageshow', event => {
    if (event.persisted) return; // BFCache : état du DOM et position déjà intacts.
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') restore();
  });
  window.addEventListener('popstate', restore);
})();